import React from 'react';
import { useParams } from 'react-router-dom';
import Section from '../Section';
import Breadcrumb from '../Breadcrumb';
import ServiceSectionList, {
  TYPE_LABELS,
} from '../Section/ServiceSection/ServiceSectionList';
import { pageTitle } from '../../helpers/PageTitle';

export default function ServiceList() {
  const { type } = useParams();
  const title = TYPE_LABELS[type] || 'Dịch vụ';

  pageTitle(title);
  return (
    <>
      <Section topMd={170} bottomMd={96} bottomLg={70}>
        <Breadcrumb title={title} />
      </Section>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        <ServiceSectionList type={type} />
      </Section>
    </>
  );
}
